import { TeamQueryParams } from 'types';
import { TeamLocalActionTypes } from './types';
import { action } from 'typesafe-actions';

export const getTeamsStart = (params: TeamQueryParams) =>
  action(TeamLocalActionTypes.GET_TEAMS_START, params);
export const getTeamsSuccess = (data: any) =>
  action(TeamLocalActionTypes.GET_TEAMS_SUCCESS, data);
export const getTeamsFailure = (error: string) =>
  action(TeamLocalActionTypes.GET_TEAMS_FAILURE, error);
